import { useRef } from 'react'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { Button, message, Select, Spin } from 'antd'
import { useSetState } from 'ahooks'
import { getJdPin, bindJdOrder } from '@/services/order'
import { getJdOrderList } from '@/services/jd'
interface IProps {
  title: string
  orderId: string
  open: boolean
  detailsInfo: Record<string, any>
  setOpen: (open: boolean) => void
  reloadDetail?: () => void
}
export default function LinkJd(prpos: IProps) {
  const formRef = useRef(null)
  const { open, title, setOpen, orderId, detailsInfo, reloadDetail } = prpos
  const [state, setState] = useSetState<any>({
    loading: false,
    btnLoading: false,
    jdOrderList: [],
    orderInfo: {},
    jdPin: '',
  })

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setState({ btnLoading: true })
        console.log(values)
        let submitObj = {
          orderId: orderId,
          sourceType: 'JD',
          sourceNo: values.projectId,
          quoteGoodsId: detailsInfo?.id,
        }
        bindJdOrder(submitObj)
          .then(res => {
            message.success('提交成功')
            reloadDetail?.()
            onCancel()
          })
          .finally(() => {
            setState({ btnLoading: false })
          })
      })
  }
  const onCancel = () => {
    onFormRef()?.resetFields()
    setOpen(false)
  }

  const getOptions = async () => {
    // 获取京东Pin信息
    let resData: any = await getJdPin(detailsInfo?.trackId)
    let jdOrderList: any = await getJdOrderList({
      data: {
        pin: resData.jdPin,
        orderStatus: '1',
        orderType: '20',
        bindShjOrderFlag: false,
        projectStatusIn: ['10'],
        shjStoreIdOrPoolStoreIdIsNull: detailsInfo?.orgId,
      },
    })
    jdOrderList = jdOrderList.map((item: any) => ({
      ...item,
      showName: `${item.orderId}      ￥${item.orderPrice} `,
    }))
    setState({ jdOrderList })
    return Promise.resolve({ jdOrderList })
  }
  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            {/* disabled={state.errInfo.length} */}
            <Button
              style={{ marginLeft: 15 }}
              loading={state.btnLoading}
              type="primary"
              onClick={onsubmit}
            >
              提交
            </Button>
          </div>
        ),
        maskClosable: false,
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <p>
              绑定前请确保客户在京东的手机号与线索手机号一致；绑定后不可修改与京东关联的订单
            </p>
            <div>
              <SGeneralForms
                ref={formRef}
                httpOptionsFn={getOptions}
                layout={'vertical'}
                configs={[
                  {
                    formItem: [
                      {
                        spanCol: 24,
                        label: '',
                        name: 'projectId',
                        children: (
                          <Select
                            placeholder={'请选择京东订单'}
                            showSearch
                            optionFilterProp="showName"
                            fieldNames={{ label: 'showName', value: 'projectId' }}
                            allowClear
                            options={state.jdOrderList}
                            onChange={val => {
                              setState({
                                orderInfo:
                                  state.jdOrderList.find(item => item.projectId === val) || null,
                              })
                            }}
                          />
                        ),
                      },
                      {
                        spanCol: 24,
                        label: '',
                        name: '',
                        isDeps: true,
                        deps: form => form.getFieldsValue().projectId,
                        children: (
                          <div>
                            <p>京东商品：{state.orderInfo?.skuName}</p>
                            <p>京东门店：{state.orderInfo?.storeName}</p>
                            <p>订单金额：{state.orderInfo?.orderPrice}元</p>
                          </div>
                        ),
                      },
                    ],
                  },
                ]}
              />
            </div>
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
